
import { Button, withStyles } from 'material-ui';
import PropTypes from 'prop-types';
import React from 'react';

const styles = theme => ({

    flatButtonStyle: {
        width: '48px',
        height: '48px',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: '#b6b8b9',
        margin: '8px',
        maxWidth: '48px',
        minWidth: '48px',
        backgroundColor: theme.palette.primary.main
    },
    selectedButton: {
        background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
        borderRadius: 3,
        border: 0,
        height: 48,
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .30)',
    }
});

class PaginationButton extends React.Component {

    render() {

        const { classes, value, isActive, onClick, styleButton, stylePrimary } = this.props;

        return !styleButton ? (
            <Button
                color={isActive ? 'primary' : ''}
                onClick={onClick}
                classes={{ root: classes.flatButtonStyle}}
                className={isActive ? 'active' : ''}
                style={{ backgroundColor: !isActive ? '#ffffff' : '' }}
            >
                <span style={{
                    maxWidth: '48px',
                    color: isActive ? '#ffffff' : '',
                }}>
                    {value ? value.toFixed(0) : ''}
                </span>

            </Button >
        ) : (
            <div
                className={isActive ? stylePrimary : styleButton}
                label={value ? value.toFixed(0) : ''}
                onClick={onClick}>
                {value ? value.toFixed(0) : ''}
            </div>
        );
    }

}

PaginationButton.propTypes = {
    value: PropTypes.number,
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
    styleButton: PropTypes.object,
    stylePrimary: PropTypes.object,
};


export default withStyles(styles)(PaginationButton);


// WEBPACK FOOTER //
// ./src/ui/PaginationButton.js